module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-tips span-full bgblack",
    attrs: {
      "id": "tips",
      "data-type": "layout"
    }
  }, [_c('div', {
    staticClass: "full-inner span-blocks span-3"
  }, _vm._l((_vm.tips), function(item, key) {
    return _c('div', {
      staticClass: "item figure",
      class: _vm.direction[Math.floor(Math.random() * _vm.direction.length)]
    }, [_c('div', {
      staticClass: "face flip item-content pl3 pr3",
      class: 'bg' + item.background_color
    }, [_c('h3', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "face flop item-bg",
      class: 'bg' + item.background_color
    }, [_c('div', {
      staticClass: "item-icon",
      class: 'icon-slider-' + parseInt(key)
    })])])
  })), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "2"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ee222598!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Solutions-tips.vue
// module id = 171
// module chunks = 1